module.exports = __webpack_public_path__ + "img/c82a74593016c882a8b6e3ad14e3347a.png";